export const isStringifiedNull = <T>(value: T): boolean => value === 'null';
